import { render, staticRenderFns } from "./RsaPrestazioniComponent.vue?vue&type=template&id=7a01241b"
import script from "./RsaPrestazioniComponent.vue?vue&type=script&lang=js"
export * from "./RsaPrestazioniComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports